import { type TOption, TIngredient } from './types'
import { removeVietnameseTones } from 'core/utils/helper'

export const sortBy: TOption[] = [
  { label: 'ingredient.filter_newest', value: 'newest' },
  { label: 'ingredient.filter_oldest', value: 'oldest' },
  { label: 'ingredient.filter_alphabet', value: 'alphabet' },
]

export const sortIngredients = (ingredients: TIngredient[], sort: TOption) => {
  let result: TIngredient[] = [...ingredients] || [] as TIngredient[];

  // Remove duplicates based on `id`
  result = result.filter(
    (obj: TIngredient, index: number, arr: TIngredient[]) =>
      arr.findIndex(o => o.id === obj.id) === index
  );

  if (result.length) {
    if (sort.value === 'alphabet') {
      result = result.sort((a: TIngredient, b: TIngredient) => {
        if (a?.name && b?.name) {
          return removeVietnameseTones(a.name).localeCompare(removeVietnameseTones(b.name));
        }
        return 0; // Default to "equal" when names are missing
      });
    }

    if (sort.value === 'newest') {
      result = result.sort((a: any, b: any) => {
        if (a?.created_at && b?.created_at) {
          const dateComparison = new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
          if (dateComparison === 0) {
            // Sort by `id` ascending if dates are the same
            return a.id - b.id;
          }
          return dateComparison;
        }
        return 0; // Default to "equal" when `created_at` is missing
      });
    }

    if (sort.value === 'oldest') {
      result = result.sort((a: any, b: any) => {
        if (a?.created_at && b?.created_at) {
          const dateComparison = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
          if (dateComparison === 0) {
            // Sort by `id` descending if dates are the same
            return b.id - a.id;
          }
          return dateComparison;
        }
        return 0; // Default to "equal" when `created_at` is missing
      });
    }
  }

  return result;
};


export const getMyIngredientKey = (id: number, lang: string): string => {
  console.log(id, lang);
  
  return `ingredients_${id}`
}

export const getMyIngredients = (id: number, lang: string): TIngredient[] => {
  const name = getMyIngredientKey(id, lang);

  return JSON.parse(localStorage.getItem(name) || '[]') || [] as TIngredient[]
}

export const setMyIngredients = (
  id: number,
  lang: string,
  data: TIngredient[]
): void => {
  const serializedState = JSON.stringify(data);
  const name = getMyIngredientKey(id, lang);
  localStorage.setItem(name, serializedState);
}

const mergeDataMyIngredients = (
  oldData: TIngredient[],
  newData: TIngredient[]
): TIngredient[] => {
  return newData.map((item: TIngredient) => {
    const index = oldData.findIndex((e: TIngredient) => e.id === item.id)
    if (index > -1) {
      const oldName = oldData[index].name;
      let name = item.name;
      if (oldName && name && removeVietnameseTones(oldName) === removeVietnameseTones(name)) {
        name = oldName;
      }
      return {
        ...oldData[index],
        name: name,
      }
    }
    return item
  })
}

export const updateMyIngredients = (
  id: number,
  lang: string,
  oldData: TIngredient[],
  newData: TIngredient[]
): TIngredient[] => {
  newData = mergeDataMyIngredients(oldData, newData)
  const serializedState = JSON.stringify(newData);
  const name = getMyIngredientKey(id, lang);
  localStorage.setItem(name, serializedState);

  return newData
}

export const getMyIngredientRequestKey = (id: number, lang: string): string => {
  console.log(lang, id)
  return `ingredient_request_${id}`
}

export const getMyIngredientRequest = (
  id: number,
  lang: string
): TIngredient[] => {
  const name = getMyIngredientRequestKey(id, lang);

  return JSON.parse(localStorage.getItem(name) || '[]') || [] as TIngredient[]
}

const removeDuplicate = (data: TIngredient[]): TIngredient[] => {
  return [...data].filter(
    (obj, index, arr) => {
    return arr.findIndex(o => o.id === obj.id) === index
  });
}

export const setMyIngredientRequest = (
  id: number,
  lang: string,
  oldData: TIngredient[],
  data: TIngredient[],
): void => {
  // const oldData = getMyIngredientRequest(id, lang)
  const newData: TIngredient[] = removeDuplicate([...oldData, ...data]);
  const serializedState = JSON.stringify(newData);
  const name = getMyIngredientRequestKey(id, lang);
  localStorage.setItem(name, serializedState);
}

export const updateMyIngredientsRequest = (
  id: number,
  lang: string,
  oldData: TIngredient[],
  newData: TIngredient[]
): TIngredient[] => {
  newData = mergeDataMyIngredients(oldData, newData)
  const serializedState = JSON.stringify(newData);
  const name = getMyIngredientRequestKey(id, lang);
  localStorage.setItem(name, serializedState);

  return newData
}
